import { createMuiTheme } from "@material-ui/core";
import shadows from "./shadows";
import typography from "./typography";

const theme = createMuiTheme({
  palette: {
    background: {
      dark: "#CFCFCF",
      default: "#FEFEFE",
      paper: "#FEFEFE",
    },
    primary: {
      main: "#E93A24",
    },
    secondary: {
      main: "#CFCFCF",
    },
    text: {
      primary: "#111111",
      secondary: "#111111",
    },
  },
  shadows,
  typography,
});

export default theme;
